module.exports = __webpack_public_path__ + "static/img/addtocartAni.fcd4310.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/addtocartAni.png
// module id = ljkJ
// module chunks = 2